import indexCart from "../modules/cart/indexCart";
import initDialogs from "../modules/header/components/initDialogs";
import checkoutJs from "../modules/checkout";
import account from "../modules/account/account";
import Logout from "../modules/account/logout";
import {ValidateLogin} from '../modules/validators/indexValidator';
import NewsletterAction from '../modules/newsletterAction';
import addScrollToTop from '../modules/addScrollToTop';
import { GetCartInfo, GetCart } from "../modules/cart/components/cart";

import "../../../scss/pages/allStyles.scss";

jQuery(function() {
  indexCart();
  checkoutJs();
  account();
  initDialogs();
  addScrollToTop();

  $('#btnLogin').on('click', function () {
    ValidateLogin($(this))
  })

  $('.loggaut').on('click', function () {
    Logout($(this))
  })

  $('.subscription').on('click', function() {
      NewsletterAction($(this));
  });

  $(".btn-back").not(".no-history").on("click", function () {
    history.back();
  });

  GetCartInfo(GetCart(true));
})